import React from 'react';
import { Text } from '@shell-b2c/web-design-system';
import { DARK_GREY, RED, WHITE } from '../../shared/colors';
import { makeStyles } from '@mui/styles';
import { newBrandTitleStyle } from '../styles/newBrand';

function Title({ variant = 'h5', children, className, newBrand, center, ...props }) {
  const classes = useStyles();

  return (
    <Text
      variant={variant}
      style= { 
        {
          ...(newBrand ? newBrandTitleStyle : {}),
          ...(center ? { textAlign: 'center' } : {})
        }
      }
      className={`${classes.title} ${className ? classes[className] : ''}`}
      gutterBottom
      {...props}
      data-testid="title"
    >
      <span className={classes.childWrapper}>{children}</span>
    </Text>
  );
}

const useStyles = makeStyles({
  title: {
    position: 'relative',
    color: RED,
    marginBottom: '16px',
    backgroundColor: WHITE,
    marginTop: '0.67rem',
  },
  childWrapper: {
    // [SSO-3862]. Fix Safari iOS
    backgroundColor: WHITE,
    padding: '0 0 3px 0',
  },
  airMiles: {
    margin: '10px 0px',
    color: DARK_GREY,
  },
  titleAttach: {
    marginTop: '1rem',
    margin: 0,
    textAlign: 'center',
  },
});

export default Title;
